const minimumLengthStyles = theme => ({
  root: {
    fontSize: 12,
    color: theme.palette.grey[500]
  }
});

export default minimumLengthStyles;
